//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import StateBox from "../../component/content/StateBox";
import MyPageProduct from "../../component/content/MyPageProduct";
import DefaultPop from "../../component/popup/DefaultModal";
import BasicBtn from "../../component/button/BasicBtn";
import MypageBtn from "../../component/button/MypageBtn";
// img
import product from "../../assets/img/picture/product_01.jpg";
import more from "../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../utils/MT";

// 처리완료

// 취소/교환/반품 상세 페이지입니다!
export default function ProductInfo(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    // 상품 정보
    const productDataList = [
        // 취소일 경우
        {
            id: 1,
            productImg: product,
            itemName: "type A530",
            price: "9,900,000",
            option: "[type A530 + smartStation™]",
            num: 1,
            delivery: "무료배송",
            cancelInfo: "다른 상품 잘못 주문",
            state: 1,
        },

        // 교환일 경우
        // {
        //     id: 2,
        //     productImg: product,
        //     itemName: "type A530",
        //     price: "9,900,000",
        //     option: '[type A530 + smartStation™]',
        //     num: 1,
        //     delivery:'무료배송',
        //     cancelInfo:'다른상품이 배송됨',
        //     state: 3,
        // },

        // 반품일 경우
        // {
        //     id: 3,
        //     productImg: product,
        //     itemName: "type A530",
        //     price: "9,900,000",
        //     option: '[type A530 + smartStation™]',
        //     num: 1,
        //     delivery:'무료배송',
        //     cancelInfo:'다른상품이 배송됨',
        //     state: 5,
        // },
    ];

    return (
        <>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>주문상품정보</MyPageTitle>
            </MyPageTitleBox>
            <OrderTableWrap>
                {/* 테이블 제목 */}
                <PC>
                    <TabelTitle>
                        <OrderTableTitle>상품정보</OrderTableTitle>
                        <OrderTableTitle>배송비</OrderTableTitle>
                        <OrderTableTitle>취소사유</OrderTableTitle>
                        <OrderTableTitle>진행상태</OrderTableTitle>
                    </TabelTitle>
                </PC>
                <CancelContentWrap>
                    {/* 테이블 리스트 */}
                    {productDataList.map((item, index) => {
                        return (
                            <OrderListBox key={"productList" + index}>
                                <MyPageProduct
                                    key={"productList" + index}
                                    id={item.id}
                                    productImg={item.productImg}
                                    itemName={item.itemName}
                                    price={item.price}
                                    num={item.num}
                                    option={item.option}
                                    i={item.id}
                                />
                                <PC>
                                    <DelText>{item.delivery}</DelText>
                                </PC>
                                <CancelText>{item.cancelInfo}</CancelText>
                                <MypageBtn state={item.state} />
                            </OrderListBox>
                        );
                    })}
                </CancelContentWrap>
            </OrderTableWrap>
        </>
    );
}

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const OrderTableWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const TabelTitle = styled.li`
    display: flex;
    align-items: center;

    padding: calc(100vw * (15 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;
    }
`;
// const TableList = styled.div`

//     &:nth-child(1) {
//         margin-right: calc(100vw * (40 / 1920));
//     }
//     & span {
//         font-family: "Noto-M";
//         margin-left: calc(100vw * (10 / 1920));
//     }

//     @media screen and (max-width: 1300px) {
//         font-size: calc(100vw * (15 / 1300));

//         &:nth-child(1) {
//             margin-right: calc(100vw * (40 / 1300));
//         }
//         & span {
//             margin-left: calc(100vw * (10 / 1300));
//         }
//     }

//     @media screen and (max-width: 900px) {
//         font-size: ${M(15)};

//         &:nth-child(1) {
//             margin-right: ${M(40)};
//         }
//         & span {
//             margin-left: ${M(10)};
//         }
//     }
// `;
const OrderTableTitle = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    font-family: "Noto-M";

    font-size: calc(100vw * (15 / 1920));

    &:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (385 / 1920));
    }
    &:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        width: calc(100vw * (135 / 1920));
    }
    &:nth-child(3) {
        width: calc(100vw * (185 / 1920));
    }
    &:nth-child(4) {
        width: calc(100vw * (165 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:nth-child(1) {
            width: calc(100vw * (385 / 1300));
        }
        &:nth-child(2) {
            width: calc(100vw * (135 / 1300));
        }
        &:nth-child(3) {
            width: calc(100vw * (185 / 1300));
        }
        &:nth-child(4) {
            width: calc(100vw * (165 / 1300));
        }
    }

    /* 
    @media screen and (max-width: 900px) {
        &:nth-child(1) {
            width: ${M(365)};
        }
        &:nth-child(2) {
            width: ${M(135)};
        }
        &:nth-child(3) {
            width: ${M(170)};
        }
        &:nth-child(4) {
            width: ${M(200)};
        }
    } */
`;
const MoreBtn = styled.button`
    margin-left: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-left: ${M(10)};
    }
`;

const CancelContentWrap = styled.ul``;

const OrderListBox = styled.li`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    & > div {
        text-align: center;
    }
    & > div:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (385 / 1920));
    }
    & > div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        width: calc(100vw * (135 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (185 / 1920));
    }
    & > div:nth-child(4) {
        width: calc(100vw * (165 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & > div:nth-child(1) {
            width: calc(100vw * (385 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (135 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (185 / 1300));
        }
        & > div:nth-child(4) {
            width: calc(100vw * (165 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        border-top: 1px solid #000000;
        padding: ${M(20)} 0;

        & > div:nth-child(1) {
            width: 100%;
        }
        & > div:nth-child(2) {
            width: 100%;
            justify-content: left;

            padding-left: ${M(98)};
        }
        & > div:nth-child(3) {
            width: 100%;
            align-items: end;
        }
        & > div:nth-child(4) {
            width: 100%;
        }
    }
`;
const DelText = styled.div`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;
const CancelText = styled.div`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-top: ${M(10)};
    }
`;
